export const SharedConst = {
    // Line-Graph
    LINE_TYPE: {
        DASHED: 'dashed',
        NON_DASHED: 'non-dashed'
    }
};
